// extracted by mini-css-extract-plugin
export var productImage = "_l4-1";
export var viewLink = "_l4-2";
export var wishlistItem = "_l4-0";